import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import DeleteConfirmModal from "components/common/DeleteConfirmModal";
import Button from "components/common/Button/Button";
import NewTag from "components/common/NewTag";

const CommonCartingseries = (props) => {
  const {
    setAddNewSeries,
    _id = null,
    pricingTypes,
    sizes,
    addNewSeries,
    saveData,
    deleteData,
    category,
    pricePerUom,
    editData = false,
    setAdd,
    cartingTypes = [],
  } = props;

  const [pricingType, setCartingType] = useState(pricingTypes);
  const [size, setSize] = useState(sizes);
  const [pricePerUOM, setPricePerUom] = useState(pricePerUom);
  const [edit, setEdit] = useState(editData);
  const [isDelete, setIsDelete] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteModal = () => (
    <DeleteConfirmModal
      isOpen={isDelete}
      toggle={() => !isDeleting && setIsDelete(false)}
      isLoading={isDeleting}
      onConfirm={() => {
        setIsDeleting(true);
        deleteData(_id, {
          onSuccess: () => { setIsDeleting(false); setIsDelete(false); },
          onError: () => { setIsDeleting(false); setIsDelete(false); },
        });
      }}
    />
  );

  const handleChange = (e, callback) => {
    callback(e.target.value);
  };

  const handleOnClickSave = () => {
    setIsSaving(true);
    saveData(
      { category, pricePerUOM, size, pricingType, _id },
      {
        onSuccess: () => { setIsSaving(false); setEdit(false); setAdd(false); setAddNewSeries(false); },
        onError: () => setIsSaving(false),
      }
    );
  };

  const handleOnClickCancel = () => {
    if (addNewSeries) {
      setAdd(false);
      setAddNewSeries(false);
    }
    setEdit(false);
    setCartingType(pricingTypes);
    setSize(sizes);
    setPricePerUom(pricePerUom);
  };

  return (
    <>
      {isDelete && deleteModal()}

      <Row style={{ marginBottom: "15px" }}>
        <Col md="3">
          <Form.Group style={{ position: "relative" }}>
            <NewTag createdAt={props.priceData?.createdAt} />
            <Form.Control
              as="select"
              name="pType"
              value={pricingType}
              disabled={!edit}
              onChange={(event) => handleChange(event, setCartingType)}
              style={{ textAlign: "center", fontSize: "0.8rem" }}
            >
              <option value="">Choose...</option>
              {cartingTypes.map((t) => (
                <option key={t.value} value={t.label}>{t.label}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>

        <Col md="3">
          <Form.Group>
            <Form.Control
              type="number"
              name="pType"
              value={size}
              disabled={!edit}
              onChange={(event) => handleChange(event, setSize)}
              style={{ textAlign: "center", fontSize: "0.8rem" }}
            ></Form.Control>
          </Form.Group>
        </Col>

        <Col md="3">
          <Form.Group>
            <Form.Control
              type="number"
              name="pType"
              value={pricePerUOM}
              disabled={!edit}
              onChange={(event) => handleChange(event, setPricePerUom)}
              style={{ textAlign: "center", fontSize: "0.8rem" }}
            ></Form.Control>
          </Form.Group>
        </Col>

        {(addNewSeries && !_id) ? (
          <Col md="2">
            <Row>
              <Col md="6">
                <Button
                  variant="success"
                  size="sm"
                  textSize="sm"
                  style={{ width: "60px" }}
                  onClick={handleOnClickSave}
                  isLoading={isSaving}
                  disabled={isSaving}
                >
                  Save
                </Button>
              </Col>
              <Col md="6">
                <Button
                  variant="danger"
                  size="sm"
                  onClick={handleOnClickCancel}
                  disabled={isSaving}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </Col>
        ) : (
          <Col md="2">
            <Row>
              <Col md="6">
                {!edit ? (
                  <Button
                    variant="primary"
                    size="sm"
                    textSize="sm"
                    style={{ width: "60px" }}
                    onClick={() => setEdit(!edit)}
                  >
                    Edit
                  </Button>
                ) : (
                  <Button
                    variant="success"
                    size="sm"
                    textSize="sm"
                    style={{ width: "60px" }}
                    onClick={handleOnClickSave}
                    isLoading={isSaving}
                    disabled={!pricePerUOM || !size || !pricingType || isSaving}
                  >
                    Save
                  </Button>
                )}
              </Col>
              {!edit && (
                <Col md="6">
                  <Button
                    variant="danger"
                    size="sm"
                    textSize="sm"
                    onClick={() => setIsDelete(true)}
                  >
                    Delete
                  </Button>
                </Col>
              )}

              {edit && (
                <Col md="6">
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={handleOnClickCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
        )}
      </Row>
    </>
  );
};

export default CommonCartingseries;
